import React, { PureComponent } from "react";
import _ from "lodash";
import { Image } from '../../components';

import f1Png from "./f1.png";
import f2Png from "./f2.png";
import f3Png from "./f3.png";
import f4Png from "./f4.png";
import f5Png from "./f5.png";
import f6Png from "./f6.png";
import f7Png from "./f7.png";
import f8Png from "./f8.png";
import f9Png from "./f9.png";

const data = {
  1: f1Png,
  2: f2Png,
  3: f3Png,
  4: f4Png,
  5: f5Png,
  6: f6Png,
  7: f7Png,
  8: f8Png,
  9: f9Png
};

export default class Feather extends PureComponent {
  static defaultProps = {
    type: 1
  };
  render() {
    const { type } = this.props;
    return <Image src={_.get(data, type)} alt="" />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Feather/index.js